import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import ChurchesListChild from "./ChurchesListChild";

const ChurchesList = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <ChurchesListChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default ChurchesList;
